import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="payment-check"
export default class extends Controller {
  connect() {
    console.log("connect paymentCheck controller");
  }

  mask_zero_difference() {
    const rows = document.querySelectorAll("tbody tr");
    rows.forEach((row) => {
      const differenceCell = row.querySelector(".difference");
      if (differenceCell && differenceCell.textContent.trim() === "0") {
        row.style.display = "none";
      }
    });
  }
}
